import Link from "next/link";

import { Project } from "interfaces";

import { useFetchDataFile } from "modules/data-files/api";
import { projectIsSalesEffectiveness } from "flows/sales-effectiveness/interfaces";

import * as flowConfig from "flows/sales-effectiveness/config";

const DataFileSummary = ({ project }: { project: Project }) => {
  const inputData = project.data_files[flowConfig.INPUT_DATA] as string;

  const { data: fileDetails } = useFetchDataFile(inputData, true);

  if (!projectIsSalesEffectiveness(project)) {
    return null;
  }

  return (
    <div className="m-1">
      <p className="mb-2">
        <span className="font-semibold">Input Data:</span>{" "}
        <Link href={`/data-files/${inputData}`}>
          <a className="text-primary-main">{fileDetails?.name || inputData}</a>
        </Link>
      </p>
    </div>
  );
};

export default DataFileSummary;
